import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Api from '../../services/ApiService';

class ChatBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: '',
    };

    this.sendMessage = this.sendMessage.bind(this);
  }

  sendMessage(e) {
    const { room } = this.props;
    const { message } = this.state;

    e.preventDefault();

    if (!message.trim()) {
      return;
    }

    Api.post(`chat/room/${room}`, {
      message,
    });

    this.setState({ message: '' });
  }

  render() {
    return (
      <form onSubmit={this.sendMessage}>
        <input className="msg-box" value={this.state.message} type="text" placeholder="Send Message" onChange={e => this.setState({ message: e.target.value })} />
        <input disabled={!this.state.message} type="submit" className="btn btn-primary" value="Send" />
      </form>
    );
  }
}

ChatBox.propTypes = {
  room: PropTypes.string,
};

export default ChatBox;
